import { render, staticRenderFns } from "./platformStatus.vue?vue&type=template&id=304dba1a&"
import script from "./platformStatus.vue?vue&type=script&lang=js&"
export * from "./platformStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports